export enum ProgramTypeKey {
  ADULT_PROGRAM = "ADULT_PROGRAM",
  HIGH_SCHOOL = "HIGH_SCHOOL",
  JUNIOR_PROGRAM = "JUNIOR_PROGRAM",
  UNIVERSAL_ACCESS_PROGRAM = "UNIVERSAL_ACCESS_PROGRAM",
}
